<label
  class="btn mapfre ghost tertiary small-btn form-label m-1 sendDocBtn browsefiles letter-space-17"
  for="customFile1"
>
  <ng-container *ngIf="!isAcmic">
    <img src="./assets/img/images/icon-file-upload-red.svg" alt="file upload icon" />
  </ng-container>
  Browse files
</label>
<input
  type="file"
  class="form-control d-none"
  id="customFile1"
  #myInputFile
  (change)="uploadFile($event)"
  (click)="myInputFile.value = null"
/>
